module.exports = __webpack_public_path__ + "img/law1m-m@2.6dc7fa1d.jpg";